import React from "react";
import "../../../../web/stylesheets/components/generic/edbuttoncomponent/edButton.scss";
import { Link } from "react-router-dom";
const EdButton = (props) => {
    // Checks if button or action
    const btnOrActionClass = props.btnTyp === "white-one" ||
        props.btnTyp === "tomato-red" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one" ||
        props.btnTyp === "green-btn" ||
        props.btnTyp === "red-btn" ||
        props.btnTyp === "midnight-blue" ||
        props.btnTyp === "midnight-blue-border" ||
        props.btnTyp === "midnight-blue-underline" ||
        props.btnTyp === "grey-suit" ||
        props.btnTyp === "midnight-blue-no-underline" ||
        props.btnTyp === "monochrome-light-grey"
        ? "button"
        : "";
    props.btnTyp === "black_one" ||
        props.btnTyp === "blood-red" ||
        props.btnTyp === "blood-red-border" ||
        props.btnTyp === "dark-peach" ||
        props.btnTyp === "black-underline" ||
        props.btnTyp === "tomato";
    return (React.createElement("button", { type: props.type, className: `ed_button ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${props.className ? ` ${props.className}` : ""}`, value: props.returnValue, onClick: props.onClick, disabled: props.disabled }, props.value));
};
export const EdButtonIcon = (props) => {
    // Checks if button or action
    const btnOrActionClass = props.btnTyp === "tomato-red" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one"
        ? "button"
        : "";
    return (React.createElement("button", { type: props.type, className: `ed_button ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${props.className ? ` ${props.className}` : ""}`, onClick: props.onClick, disabled: props.disabled }, props.btnIcon ? React.createElement("i", { className: props.btnIcon }) : props.value));
};
export const EdLinkButton = (props) => {
    // Checks if button or action
    const btnOrActionClass = props.btnTyp === "tomato-red" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one"
        ? "button"
        : "";
    return (React.createElement(Link, { to: props.LinkHref, type: props.type, className: `ed_button common_button ib  ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${props.className ? ` ${props.className}` : ""}` }, props.value));
};
export const EdALinkButton = (props) => {
    // Checks if button or action
    const btnOrActionClass = props.btnTyp === "tomato-red" ||
        props.btnTyp === "light-navy" ||
        props.btnTyp === "dusty-orange" ||
        props.btnTyp === "white-twenty" ||
        props.btnTyp === "kelly-green-two" ||
        props.btnTyp === "blue-one" ||
        props.btnTyp === "grey-one"
        ? "button"
        : "";
    return (React.createElement("a", { target: props.target ? props.target : "_blank", rel: "noopener noreferrer", href: props.LinkHref, type: props.type, className: `ed_button ib ${props.btnTyp} ${btnOrActionClass}${props.slim ? " slim" : ""}${props.disabled ? " disabled" : ""}${props.className ? ` ${props.className}` : ""}` }, props.value));
};
export default EdButton;
